<style scoped lang="less">

  .t97-wapper {
    width: 100%;
    background-color: #fff;
    font-size: 0px;
    .title {
      position: sticky;
      top: 0;
      width: 100%;
      z-index: 100;
      min-width: 1200px;
      height: 106px;
      background: #FFFFFF;
      color: #000;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0  7.5%;
      box-sizing: border-box;
      flex-wrap: inherit;
      .logo {
        float: left;
        width: 255px;
        height: 60px;
        cursor: pointer;
        img {
          width: 100%;
        }
      }
      .nav-model {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        .nav-item {
          margin-right: 35px;
          color: rgba(51, 51, 51, 1);
          font-size: 16px;
          line-height: 22px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          cursor: pointer;
        }
        .colorActive {
          position: relative;
          &:before{
            content: '';
            display: block;
            width: 100%;
            height: 2px;
            background: #333333;
            position: absolute;
            bottom: -5px;
            left:0;
          }
        }
        .voice-ctrl {
          img {
            width: 199px;
            height: 63px;
          }
        }
      }
    }
    .full1{
      display: flex;
      flex-direction:column ;
      justify-content: flex-start;
      font-size:0 !important;
      .section2{
        img{
          width: 100%;
          display: inline-block;
        }
      }
      .sec3{
        width: 100%;
        /*min-height: 611px;*/
        /*background: url('https://img.gegejia.com/img/70f7c15a91ba6830100de4274989ee4f.png') no-repeat;*/
        /*background-size: contain;*/
        position: relative;
        .sec3_img{
          width: 100%;
        }
        .sec3_swiper{
          position: absolute;
          left: 57%;
          top:26%;
          width: 40%;
          height: 64%;
          /*background-color: #fff;*/
          overflow: hidden;
          .slid{
            height: 80px;
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            img{
              width: 40px;
              height: 40px;
              transform: translateY(-5px);
            }
            .text{
              font-size:14px;
              color: #fff;
              margin-left: 16px;
              .date{
                width: 90px;
                border:1px solid rgba(255,255,255,0.6);
                border-radius: 12px;
                height: 24px;
                line-height: 24px;
                text-align: center;
                margin-bottom: 12px;
              }
              .con{

              }
            }
          }
        }
      }
      .sec4{
        background-color: #fff;
        .sec4_title{
          width: 100%;
        }
        .lis{
          min-width: 960px;
          max-width: 1440px;
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          align-items: flex-start;
          margin: 0 auto;
          img{
            width: 30%;
            margin: 1%;
            transition: 1s ease all;
            /*height:auto;*/
          }
          img:hover{
            transform: scale(1.1);

          }
        }
      }
    }
    .full2{
      .fl2_img{
        width: 100%;
      }
      .f5_contact{
        margin:88px 7.5% 200px;
        img{
          max-width: 100%;
        }
      }
      .am{
        margin:66px auto 52px;
        display: flex;
        justify-content: center;
        img{
          width: 690px;
          height: 303px;
        }
      }
    }
    .footer-wrapper {
      font-family: PingFangSC-Regular;
      font-weight: 400;
      width: 100%;
    //  position: absolute;
      left: 0;
      bottom: 3.6%;
      font-size: 12px;
      color: #fff;
      min-width: 1200px;
      .footer {
        margin-left: 7.5%;
        font-size: 12px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.8);
        line-height: 20px;
        .row-wrapper {
          position: relative;
          width: 100%;
          .row {
            position: relative;
            width: 78%;
            vertical-align: middle;
            .special {
              font-weight: 600;
              float: left;
              margin-right: 22px;
              line-height: 26px;
            }
            .opa {
              filter: alpha(opacity=80); /*支持 IE 浏览器*/
              -moz-opacity: 0.8; /*支持 FireFox 浏览器*/
              -khtml-opacity: 0.8; /*webkit内核浏览器*/
              opacity: 0.8;
              margin-right: 22px;
              float: left;
              line-height: 26px;
              a {
                text-decoration: none;
                color: #fff;
              }
            }
            img {
              width: 26px;
              height: 26px;
            }
            .weibo {
              margin-right: 6px;
              //float: left;
              display: inline-block;
              vertical-align: middle;
            }
            .wechat {
              margin-right: 6px;
              position: relative;
              //float: left;
              display: inline-block;
              vertical-align: middle;
              .footer-code {
                width: 26px;
                height: 26px;
                background-color: #fff;
                position: absolute;
                left: 32px;
                bottom: 4px;
                img {
                  position: absolute;
                  left: 0;
                  bottom: 0;
                  width: 120px;
                  height: 120px;
                  border-radius: 20px 20px 20px 0;
                }
              }
            }
            .pointer {
              cursor: pointer;
              a {
                display: inline-block;
                vertical-align: middle;
              }
            }
          }
          .slide-down {
            position: absolute;
            //float: right;
            right: 143px;
            bottom: 10px;
            width: 2%;
            img {
              width: 100%;
            }
          }
        }
      }
    }
    .bossss{
      display: block;
      color: #ccc;
      text-decoration: none;
    }
  }
</style>
<template>
  <div class="t97-wapper">
    <div class="title">
      <div class="logo" >
        <img src="https://img.gegejia.com/img/4d61f2cbc575b5b88a223e7dc11405c7.png" alt />
      </div>
      <div class="nav-model">
        <div class="nav-item" @click="toFloorNum(1)" :class="{'colorActive': sectionIndex == 1}">首页</div>
        <div class="nav-item" @click="toFloorNum(2)" :class="{'colorActive': sectionIndex == 2}">关于T97</div>
        <div class="nav-item" @click="toFloorNum(3)" :class="{'colorActive': sectionIndex == 3}">产品介绍</div>
        <div class="nav-item" @click="toFloorNum(4)" :class="{'colorActive': sectionIndex == 4}">门店介绍</div>
        <div class="nav-item" @click="toFloorNum(5)" :class="{'colorActive': sectionIndex == 5}">联系我们</div>
         <div class="nav-item voice-ctrl" >
           <img  src="https://img.gegejia.com/img/40f62bcb3c7cd2d65bd05da1fa251c64.png" alt="">
         </div>
      </div>
    </div>
    <div class="full1" v-show="sectionIndex === 1">
      <Floor1 ref="myChild"></Floor1>
      <div class="section2">
        <img src="https://img.gegejia.com/img/e4a31889ab322328df3edddd612234ca.png" alt="">
        <img src="https://img.gegejia.com/img/26b4a9cadb9339285381232ba8cf573a.png" alt="">
      </div>
      <div class="sec3">
        <img src="https://img.gegejia.com/img/70f7c15a91ba6830100de4274989ee4f.png" class="sec3_img" alt="">
        <swiper :options="swiperOption" ref="mySwiper" class="sec3_swiper">
          <swiper-slide  class="slid" v-for="item in swList">
            <img class="big-img" src="https://img.gegejia.com/img/2a6e122a02d005ce5efe8c9124121484.png" alt="">
            <div class="text">
              <div class="date">{{item.date}}</div>
              <div class="con">{{item.content}}</div>
            </div>
          </swiper-slide>

        </swiper>
      </div>
      <div class="sec4">
        <img src="https://img.gegejia.com/img/ab8c57d7755b9641cb06f9abe1770c0a.png" alt="" class="sec4_title">
        <div class="lis">
          <img src="https://img.gegejia.com/img/89efdce148a4c955b6fece8857f42b6c.png" alt="">
          <img src="https://img.gegejia.com/img/37b090d75db543b5d6b89d8415450d42.png" alt="">
          <img src="https://img.gegejia.com/img/6e907d8ac405fa490c7693a1b198f79f.png" alt="">
          <img src="https://img.gegejia.com/img/d91ebfb7a3a148ef9c4d9a39c05ef375.png" alt="">
          <img src="https://img.gegejia.com/img/28f219fefad57efc6be0e52e9f5cf407.png" alt="">
          <img src="https://img.gegejia.com/img/fee461ed8b21984a816fbd9ffcc19b33.png" alt="">
        </div>
        <img src="https://img.gegejia.com/img/f28e31b79b094af2e963c3dd7071d92e.png" class="sec4_title" alt="">
        <img src="https://img.gegejia.com/img/526bb1f3452266efb62b83d8463a84fd.png" class="sec4_title" alt="">
      </div>
    </div>
    <div class="full2" v-show="sectionIndex === 2">
      <img src="https://img.gegejia.com/img/e4a31889ab322328df3edddd612234ca.png"  class="fl2_img"alt="">
      <div class="am">
        <img src="https://img.gegejia.com/img/d6e5e05bf02048a8a1911fa3841a67a3.png" alt="">
      </div>
      <img src=" https://img.gegejia.com/img/6ff199f487db4338dc62bd4eda6856f2.png"  class="fl2_img"alt="">
    </div>
    <Floor3 v-show="sectionIndex === 3"></Floor3>
    <Floor4 v-show="sectionIndex === 4"></Floor4>
    <div class="full5 full2" v-show="sectionIndex === 5">
      <img src="https://img.gegejia.com/img/993f0312418b22a1c955f29db36d82bc.png"  class="fl2_img"alt="">
      <div class="f5_contact">
        <img src="https://img.gegejia.com/img/29a6cb4011e62c441c3ba8e4b94560a7.png"  alt="">
      </div>

    </div>
    <Footer></Footer>
  </div>
</template>

<script>
//import "@/assets/css/jquery.fullPage.css";
//import "@/assets/js/jquery.easings.min.js";
//import "@/assets/js/jquery.fullPage.js";
// import getBeians from "@lib/ggj-beian";
import Floor1 from "@/views/t97/block/floor_1";
import Floor3 from "@/views/t97/block/floor_3";
import Floor4 from "@/views/t97/block/floor_4";
import Footer from "@/views/t97/block/footer";

import { swiper, swiperSlide } from "vue-awesome-swiper";
import("swiper/dist/css/swiper.css");


export default {
  data() {
    return {
      sectionIndex: 1,
      footerCodeVisible: false,
      voiceVisible: true,
      swiperOption: {
        notNextTick: false,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
        },
        direction: 'vertical',
//				observer: true,
//				observeParents: true,
        wrapperClass: "swiper-wrapper",
        loop: true,
        loopAdditionalSlides: 3,
        height:80,
//				width: 268,
//				spaceBetween: 4,
      },
      swList: [
        {date: '2021年4月', content: 'T97咖啡单品上线仅10秒销售额达2400万，10个月累计突破10亿'},
        {date: '2021年8月', content: 'T97成功入选2021“金物奖”，新国货界的“奥斯卡”！'},
        {date: '2021年10月', content: '首次参加南京“还有咖啡节”，现场咖啡火爆热卖'},
        {date: '2021年12月', content: 'T97斩获2021「TBI」杰出品牌创新奖'},
        {date: '2021年12月', content: 'T97首家快闪咖啡店落地天目里，各届网红纷纷前来打卡'},
        {date: '2021年12月', content: 'T97 COFFEE品牌小程序正式上线，截至至今累计会员超50万'},
        {date: '2022年4月', content: '[97 GO] 咖啡车出发，参加杭州湖滨in77「春日唤醒计划'},
        {date: '2022年5月', content: '第一家标准店正式开业，T97线下布局正式拉开帷幕'},
        {date: '2022年6月', content: 'T97线下业务进入快速扩张期，计划3年内开出1001家咖啡店'},
        {date: '2022年7月', content: 'T97咖啡入选2022年中国未来独角兽之星榜单'},
        {date: '2022年8月', content: '品牌VI视觉全新升级，入选APD亚太设计年鉴，开启品牌2.0征程'},
        {date: '2022年9月', content: '与认养一头牛达成深度合作，强化产品品质是品牌核心战略'},
        {date: '2022年9月', content: 'T97抖音直播间火爆全网，截至至今累计曝光超30亿+'},
        {date: '2022年11月', content: 'T97与植物标签、卡乐比等数十家品牌玩转跨界，品牌势能崛起'},
      ]
    };
  },
  components: {
    Floor1,
    Floor3,
    Floor4,
    swiper,
    swiperSlide,
    Footer
  },
  created: function() {
    document.title = 'T97 COFFEE'
    let self = this;
//    $(document).ready(function() {
//      $("#fullpage").fullpage({
//        //anchors: ['firstPage', 'secondPage', 'thirdPage', 'fourthPage', 'lastPage'],
//        afterLoad: function(anchorLink, index) {
//          console.log(index, "index");
//          self.sectionIndex = index;
//        },
//        normalScrollElements: ".card"
//      }); //激活fullpage
//    });
  },
  computed: {

  },
  methods: {
    goto(v) {
      if (v === 1) {
        window.open("https://cdn.gegejia.com/fe-ui/bm/%E8%BF%85%E5%85%B0%E8%90%A5%E4%B8%9A%E6%89%A7%E7%85%A7%EF%BC%9A91330106MA2CE07531.jpg");
      } else if (v ===2 ){
        window.open("https://cdn.gegejia.com/fe-ui/bm/%E9%A3%9F%E5%93%81%E7%BB%8F%E8%90%A5%E8%AE%B8%E5%8F%AF%E8%AF%81%EF%BC%9AJY13301060024385.jpg");

      } else if (v ===3 ){
        window.open("https://cdn.gegejia.com/fe-ui/bm/%E7%AC%AC%E4%BA%8C%E7%B1%BB%E5%8C%BB%E7%96%97%E5%99%A8%E6%A2%B0%E7%BB%8F%E8%90%A5%E5%A4%87%E6%A1%88%E5%87%AD%E8%AF%81%EF%BC%9A%E6%B5%99%E6%9D%AD%E9%A3%9F%E8%8D%AF%E7%9B%91%E6%A2%B0%E7%BB%8F%E8%90%A5%E5%A4%8720191771%E5%8F%B7.jpg");

      } else if (v ===4 ){
        window.open("https://cdn.gegejia.com/fe-ui/bm/%E5%8C%BB%E7%96%97%E5%99%A8%E6%A2%B0%E7%BB%8F%E8%90%A5%E8%AE%B8%E5%8F%AF%E8%AF%81%EF%BC%88%E4%B8%89%E7%B1%BB%EF%BC%89%EF%BC%9A%E6%B5%99%E6%9D%AD%E9%A3%9F%E8%8D%AF%E7%9B%91%E6%A2%B0%E7%BB%8F%E8%90%A5%E8%AE%B820190525%E5%8F%B7.jpg");

      } else if (v ===5 ){
        window.open("https://cdn.gegejia.com/fe-ui/bm/%E5%87%BA%E7%89%88%E7%89%A9%E7%BD%91%E7%BB%9C%E4%BA%A4%E6%98%93%E5%B9%B3%E5%8F%B0%E6%9C%8D%E5%8A%A1%E7%BB%8F%E8%90%A5%E5%A4%87%E6%A1%88%E8%AF%81%EF%BC%9A%E6%96%B0%E5%87%BA%E5%8F%91%E6%B5%99%E5%A4%87%E5%AD%97%E7%AC%AC2019004%E5%8F%B7.png");

      } else if (v ===6 ){
        window.open("https://cdn.gegejia.com/fe-ui/bm/%E8%BF%85%E5%85%B0%E4%BA%92%E8%81%94%E7%BD%91%E8%8D%AF%E5%93%81%E4%BF%A1%E6%81%AF%E6%9C%8D%E5%8A%A1%E8%AF%81%E4%B9%A6%EF%BC%9A(%E6%B5%99)-%E7%BB%8F%E8%90%A5%E6%80%A7-2019-0142.jpg");

      } else if (v ===7 ){
        window.open("https://cdn.gegejia.com/fe-ui/bm/%E5%A2%9E%E5%80%BC%E7%94%B5%E4%BF%A1%E4%B8%9A%E5%8A%A1%E7%BB%8F%E8%90%A5%E8%AE%B8%E5%8F%AF%E8%AF%81%EF%BC%9A%E6%B5%99%20B2-20190311.jpg");

      }else if (v ===8 ){
        window.open("https://www.nmpa.gov.cn/datasearch/home-index.html?79QlcAyHig6m=1658976537218#category=ylqx");

      }
    },
    slideDown() {
      $("#fullpage").fullpage.moveSectionDown();
      //$("#fullpage").fullpage.moveTo(3)
    },
    toFloorNum(num) {
      //$("#fullpage").fullpage.moveTo(num);
      this.sectionIndex = num
      window.scrollTo(0,0)
    },
    voiceCtrl() {
      this.voiceVisible = !this.voiceVisible;
      this.$refs.myChild.muteStatusCtrl();
    },
    toRuleCenter(index) {
      this.sectionIndex = index;
      window.location.href =
        "https://h5.gegejia.com/adminUniversity/#/rules?page=1&pageSize=20&menuId=12";
    },
    jumpBeian() {
      window.open("https://beian.miit.gov.cn/");
    }
  }
};
</script>





// WEBPACK FOOTER //
// src/views/t97/index.vue